
export class PostControlNoteDto {
    noteId;
    noteContent;
    creatingPerson;
    creationDate;
    modificationPerson;
    modificationDate;
    postControlDocument;
    attachments;
}


















